module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2022-10-18 at 11.40.47 AM.8b7e7b3a.jpeg";